import React from "react";
import { useTheme } from "styled-components";
import Heading from "../../Heading/Heading";
import {
  ModalBody,
  ModalHeader,
  ModalTitle,
  ModalContainer,
  ModalCloseButton,
  ModalBackButton,
} from "./styles";
import { ModalProps } from "./types";

const Modal: React.FC<ModalProps> = ({
  title,
  onDismiss,
  onBack,
  children,
  hideCloseButton = false,
  bodyPadding = "24px",
  headerBackground = "transparent",
  minWidth = "320px",
  ...props
}) => {
  const theme = useTheme();
  return (
    <>
      <div
        style={{
          position: "fixed",
          left: "0px",
          top: "0px",
          width: "100vw",
          height: "100vh",
          background: "rgba(24, 31, 81, 0.8)",
          zIndex: 1400,
          backdropFilter: "blur(10px)",
        }}
        onClick={onDismiss}
      />
      <ModalContainer minWidth={minWidth} {...props}>
        <ModalHeader background="#ffffff">
          <ModalTitle>
            {onBack && <ModalBackButton onBack={onBack} />}
            <Heading>{title}</Heading>
          </ModalTitle>
          {!hideCloseButton && <ModalCloseButton onDismiss={onDismiss} />}
        </ModalHeader>
        <ModalBody p={bodyPadding}>{children}</ModalBody>
      </ModalContainer>
    </>
  );
};

export default Modal;
